import { useUserRoles } from '@/composables/useUserRoles'
import { useAuthStore } from '@/modules/auth/store'
import { useCounterStore } from '@/modules/counter/store'
import { useInfoStore } from '@/modules/info/store'
import { useNewsStore } from '@/modules/news/store'

export const counterMiddleware = async () => {
  const authStore = useAuthStore()
  if (!authStore.user) return true

  const counterStore = useCounterStore()
  const { isPractitioner } = useUserRoles()
  if (isPractitioner.value) {
    return true
  }
  const newsStore = useNewsStore()
  const infoStore = useInfoStore()
  const [, news, infoArticles] = await Promise.all([
    counterStore.getCounter(),
    newsStore.getNewsArticleList({ limit: 1 }),
    infoStore.getInfoArticleList({ limit: 1 }),
  ])
  newsStore.hasNews = !!news.results?.length
  infoStore.hasInfoArticles = !!infoArticles.results?.length
}
